import React, { useEffect, useState, createContext } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { HeroSection } from './components/HeroSection'
import { HowItWorksSection } from './components/HowItWorksSection'
import { BenefitsSection } from './components/BenefitsSection'
import { PricingSection } from './components/PricingSection'
import { FoundersNoteSection } from './components/FoundersNoteSection'
import { FAQSection } from './components/FAQSection'
import { TestimonialsSection } from './components/TestimonialsSection'
import { MoreThanLessonsSection } from './components/MoreThanLessonsSection'
import { VisionSection } from './components/VisionSection'
import { Navbar } from './components/Navbar'
import { Footer } from './components/Footer'
import { TeacherSignUp } from './components/pages/TeacherSignUp'
import { StudentSignUp } from './components/pages/StudentSignUp'
import { StudentLogin } from './components/pages/StudentLogin'
import { TeacherLogin } from './components/pages/TeacherLogin'
import { StudentDashboard } from './components/pages/StudentDashboard'
import { StudentMessages } from './components/pages/StudentMessages'
import { TeacherMessages } from './components/pages/TeacherMessages'
import { FindTeachers } from './components/pages/FindTeachers'
import { CompleteTeacherProfile } from './components/pages/CompleteTeacherProfile'
import { TeacherPublicProfile } from './components/pages/TeacherPublicProfile'
import { TeacherDashboard } from './components/pages/TeacherDashboard'
import { TeacherProfile } from './components/pages/TeacherProfile'
import { ReportsDashboard } from './components/pages/ReportsDashboard'
import { OnlineCourses } from './components/pages/OnlineCourses'
import { PublicCoursesPage } from './components/pages/PublicCoursesPage'
import { MyStudents } from './components/pages/MyStudents'
import { StudentSettings } from './components/pages/StudentSettings'
import { StudentSchedule } from './components/pages/StudentSchedule'
import { StudentProfilePage } from './components/pages/StudentProfilePage'
import { StudentGradesOverview } from './components/pages/StudentGradesOverview'
import { GradesManagementPage } from './components/pages/GradesManagementPage'
import { StudentDataCheck } from './components/pages/StudentDataCheck'
import { AuthProvider } from './contexts/AuthContext'
import { AuthGuard } from './components/AuthGuard'
import { ScrollToTop } from './components/ScrollToTop'
import { SignInModal } from './components/SignInModal'
import { TeacherLoginModal } from './components/TeacherLoginModal'
import { initEmailService } from './services/emailService'
import { EmailVerificationPage } from './components/pages/EmailVerificationPage'
import { InstrumentSelectionPage } from './components/pages/InstrumentSelectionPage'
import { TeacherMatchingPage } from './components/pages/TeacherMatchingPage'
import { SheetMusicPage } from './components/pages/SheetMusicPage'
import { MoonlightSonataViewer } from './components/pages/MoonlightSonataViewer'
import { PreludeInCMajorViewer } from './components/pages/PreludeInCMajorViewer'
import { ToccatinaViewer } from './components/pages/ToccatinaViewer'
import { RondoInEFlatViewer } from './components/pages/RondoInEFlatViewer'
import { PolonaiseInFViewer } from './components/pages/PolonaiseInFViewer'
import { AusMeinesHerzensGrundeViewer } from './components/pages/AusMeinesHerzensGrundeViewer'
import { IchDankDirLieberHerreViewer } from './components/pages/IchDankDirLieberHerreViewer'
import { ErmuntereDichMeinSchwacherGeistViewer } from './components/pages/ErmuntereDichMeinSchwacherGeistViewer'
import { GottWieGrossIstDeineGuteViewer } from './components/pages/GottWieGrossIstDeineGuteViewer'
import { GibDichZufriedenUndSeiStilleViewer } from './components/pages/GibDichZufriedenUndSeiStilleViewer'
import { GibDichZufriedenUndSeiStilleDMinorViewer } from './components/pages/GibDichZufriedenUndSeiStilleDMinorViewer'
import { AriaBWV515Viewer } from './components/pages/AriaBWV515Viewer'
import { WarumBetrubstDuDichViewer } from './components/pages/WarumBetrubstDuDichViewer'
import { InventionNo2Viewer } from './components/pages/InventionNo2Viewer'
import { InventionNo3Viewer } from './components/pages/InventionNo3Viewer'
import { InventionNo4Viewer } from './components/pages/InventionNo4Viewer'
import { InventionNo5Viewer } from './components/pages/InventionNo5Viewer'
import { InventionNo7Viewer } from './components/pages/InventionNo7Viewer'
import { InventionNo8Viewer } from './components/pages/InventionNo8Viewer'
import { InventionNo10Viewer } from './components/pages/InventionNo10Viewer'
import { InventionNo11Viewer } from './components/pages/InventionNo11Viewer'
import { InventionNo13Viewer } from './components/pages/InventionNo13Viewer'
import { InventionNo14Viewer } from './components/pages/InventionNo14Viewer'
import { InventionNo15Viewer } from './components/pages/InventionNo15Viewer'
import { GenericSheetMusicViewer } from './components/pages/GenericSheetMusicViewer'
import { TeacherTasks } from './components/pages/TeacherTasks'
import { StudentLayout } from './components/layouts/StudentLayout'
import { TeacherLayout } from './components/layouts/TeacherLayout'
import { RoleAwareLayout } from './components/layouts/RoleAwareLayout'
import { VirtualClassroom } from './components/pages/VirtualClassroom'
import { ToastContainer } from './components/ToastContainer'
import { PaymentMethodsPage } from './components/pages/PaymentMethodsPage'
import { TransactionHistoryPage } from './components/pages/TransactionHistoryPage'
import { SubscriptionManagementPage } from './components/pages/SubscriptionManagementPage'
import { Calendar2 } from './components/pages/Calendar2'
import { MyInfoPage } from './components/pages/MyInfoPage'
import { SettingsPage } from './components/pages/SettingsPage'
import { AccountSecurityPage } from './components/pages/AccountSecurityPage'
import { BillingPayoutsPage } from './components/pages/BillingPayoutsPage'
import { HelpSupportPage } from './components/pages/HelpSupportPage'
import { PayoutsInvoicesPage } from './components/pages/PayoutsInvoicesPage'
import { ThemeProvider, useTheme } from './components/providers/ThemeProvider'
import { ForgotPassword } from './components/pages/ForgotPassword'
import { TeacherEmailVerificationPage } from './components/pages/TeacherEmailVerificationPage'
import { VerifyEmailPage } from './components/pages/VerifyEmailPage'
import { EmailVerifiedPage } from './components/pages/EmailVerifiedPage'
import { Toaster } from 'react-hot-toast'
import { RevenuePage } from './components/pages/RevenuePage'
import { TeacherPublicProfilePage } from './components/pages/TeacherPublicProfilePage'
import { StudentSelfProfilePage } from './components/pages/StudentSelfProfilePage'
import { AboutUsPage } from './components/pages/AboutUsPage'
import { CareersPage } from './components/pages/CareersPage'
import { KnowledgeBaseGettingStarted } from './components/pages/KnowledgeBaseGettingStarted'
import { KnowledgeBaseSchedulingLessons } from './components/pages/KnowledgeBaseSchedulingLessons'
import { KnowledgeBaseVirtualClassroom } from './components/pages/KnowledgeBaseVirtualClassroom'
import { PrivacyPolicyPage } from './components/pages/PrivacyPolicyPage'
import { CookiePolicyPage } from './components/pages/CookiePolicyPage'
import { TermsOfServicePage } from './components/pages/TermsOfServicePage'
import { SignInModalContext } from './components/SignInModal'
import { TeacherLoginModalContext } from './components/TeacherLoginModal'
// Create a context for the sign in modal
export const SignInModalContext = createContext({
  isSignInModalOpen: false,
  openSignInModal: () => {},
  closeSignInModal: () => {},
  isTeacherLoginModalOpen: false,
  openTeacherLoginModal: () => {},
  closeTeacherLoginModal: () => {},
})
// Create a wrapper component that uses the theme
function AppContent() {
  const { theme } = useTheme()
  // Initialize EmailJS when the app loads
  useEffect(() => {
    initEmailService()
  }, [])
  // Global state for sign in modal
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false)
  const [isTeacherLoginModalOpen, setIsTeacherLoginModalOpen] = useState(false)
  const openSignInModal = () => {
    setIsSignInModalOpen(true)
  }
  const closeSignInModal = () => {
    setIsSignInModalOpen(false)
  }
  const openTeacherLoginModal = () => {
    setIsTeacherLoginModalOpen(true)
  }
  const closeTeacherLoginModal = () => {
    setIsTeacherLoginModalOpen(false)
  }
  return (
    <AuthProvider>
      <SignInModalContext.Provider
        value={{
          isSignInModalOpen,
          openSignInModal,
          closeSignInModal,
          isTeacherLoginModalOpen,
          openTeacherLoginModal,
          closeTeacherLoginModal,
        }}
      >
        <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <Navbar />
                    <main>
                      <HeroSection />
                      <HowItWorksSection />
                      <BenefitsSection />
                      <MoreThanLessonsSection />
                      <TestimonialsSection />
                      <FoundersNoteSection />
                      <VisionSection />
                      <PricingSection />
                      <FAQSection />
                    </main>
                    <Footer />
                  </>
                }
              />
              <Route path="/teacher-signup" element={<TeacherSignUp />} />
              <Route path="/student-signup" element={<StudentSignUp />} />
              <Route path="/student-login" element={<StudentLogin />} />
              <Route path="/teacher-login" element={<TeacherLogin />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              {/* Email verification routes - NO AUTH GUARD (must be accessible to unverified users) */}
              <Route
                path="/email-verification"
                element={<EmailVerificationPage />}
              />
              <Route
                path="/teacher-email-verification"
                element={<TeacherEmailVerificationPage />}
              />
              {/* New route for email verification success */}
              <Route path="/email-verified" element={<EmailVerifiedPage />} />
              {/* Legacy route for handling email verification links - kept for backward compatibility */}
              <Route path="/verify-email" element={<VerifyEmailPage />} />

              {/* Student routes with consistent sidebar */}
              <Route
                path="/student-dashboard"
                element={
                  <StudentLayout>
                    <StudentDashboard />
                  </StudentLayout>
                }
              />
              <Route
                path="/messages"
                element={
                  <StudentLayout>
                    <StudentMessages />
                  </StudentLayout>
                }
              />
              <Route
                path="/find-teachers"
                element={
                  <StudentLayout>
                    <FindTeachers />
                  </StudentLayout>
                }
              />
              <Route
                path="/online-courses"
                element={
                  <StudentLayout>
                    <OnlineCourses />
                  </StudentLayout>
                }
              />
              <Route
                path="/sheet-music"
                element={
                  <StudentLayout>
                    <SheetMusicPage />
                  </StudentLayout>
                }
              />
              <Route
                path="/student-settings"
                element={
                  <StudentLayout>
                    <StudentSettings />
                  </StudentLayout>
                }
              />
              {/* PHASE 2: Student self-profile route */}
              <Route
                path="/student/profile"
                element={
                  <StudentLayout>
                    <div className="min-h-screen flex items-center justify-center">
                      <p className="text-gray-500">Profile page coming soon</p>
                    </div>
                  </StudentLayout>
                }
              />
              <Route
                path="/my-profile"
                element={
                  <StudentLayout>
                    <div className="min-h-screen flex items-center justify-center">
                      <p className="text-gray-500">Profile page coming soon</p>
                    </div>
                  </StudentLayout>
                }
              />

              {/* Teacher routes - PROTECTED with email verification enforcement */}
              <Route
                path="/teacher-dashboard"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <TeacherDashboard />
                  </AuthGuard>
                }
              />
              <Route
                path="/teacher-profile"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <TeacherPublicProfilePage />
                  </AuthGuard>
                }
              />

              {/* Teacher calendar routes - PROTECTED */}
              <Route
                path="/teacher/calendar"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <TeacherLayout>
                      <Calendar2 />
                    </TeacherLayout>
                  </AuthGuard>
                }
              />
              <Route
                path="/teacher/calendar2"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <TeacherLayout>
                      <Calendar2 />
                    </TeacherLayout>
                  </AuthGuard>
                }
              />

              {/* Public teacher profile routes - NO AUTH GUARD (public pages) */}
              <Route
                path="/teachers/:teacherId"
                element={<TeacherPublicProfilePage />}
              />

              {/* Teacher-only routes - PROTECTED */}
              <Route
                path="/revenue"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <RevenuePage />
                  </AuthGuard>
                }
              />
              <Route
                path="/assigned-tasks"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <TeacherTasks />
                  </AuthGuard>
                }
              />
              <Route
                path="/reports"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <ReportsDashboard />
                  </AuthGuard>
                }
              />
              <Route
                path="/payouts"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <PayoutsInvoicesPage />
                  </AuthGuard>
                }
              />
              <Route
                path="/complete-profile"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <CompleteTeacherProfile />
                  </AuthGuard>
                }
              />
              <Route
                path="/my-students"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <MyStudents />
                  </AuthGuard>
                }
              />
              <Route
                path="/student-data-check"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <StudentDataCheck />
                  </AuthGuard>
                }
              />
              <Route
                path="/teacher-messages"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <TeacherLayout>
                      <TeacherMessages />
                    </TeacherLayout>
                  </AuthGuard>
                }
              />

              {/* Public routes - NO AUTH GUARD */}
              <Route path="/courses" element={<PublicCoursesPage />} />
              <Route
                path="/teacher/:id"
                element={<TeacherPublicProfilePage />}
              />
              <Route
                path="/public-profile/:teacherId"
                element={<TeacherPublicProfilePage />}
              />

              {/* Virtual classroom and grades - context-dependent protection */}
              <Route
                path="/student/lesson/:lessonId/join"
                element={<VirtualClassroom />}
              />
              <Route
                path="/student-grades/:studentId"
                element={<StudentGradesOverview />}
              />
              <Route
                path="/grades-management"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <GradesManagementPage />
                  </AuthGuard>
                }
              />

              {/* Teacher Sheet Music page - PROTECTED */}
              <Route
                path="/teacher-sheet-music"
                element={
                  <AuthGuard
                    requiredUserType="teacher"
                    redirectTo="/teacher-login"
                  >
                    <SheetMusicPage />
                  </AuthGuard>
                }
              />

              {/* Sheet music viewer pages - NO AUTH GUARD (public access) */}
              <Route
                path="/sheet-music/moonlight-sonata"
                element={<MoonlightSonataViewer />}
              />
              <Route
                path="/sheet-music/prelude-in-c-major"
                element={<PreludeInCMajorViewer />}
              />
              <Route
                path="/sheet-music/toccatina"
                element={<ToccatinaViewer />}
              />
              <Route
                path="/sheet-music/rondo-in-e-flat"
                element={<RondoInEFlatViewer />}
              />
              <Route
                path="/sheet-music/polonaise-in-f"
                element={<PolonaiseInFViewer />}
              />
              <Route
                path="/sheet-music/aus-meines-herzens-grunde"
                element={<AusMeinesHerzensGrundeViewer />}
              />
              <Route
                path="/sheet-music/ich-dank-dir-lieber-herre"
                element={<IchDankDirLieberHerreViewer />}
              />
              <Route
                path="/sheet-music/ermuntere-dich-mein-schwacher-geist"
                element={<ErmuntereDichMeinSchwacherGeistViewer />}
              />
              <Route
                path="/sheet-music/gott-wie-gross-ist-deine-gute"
                element={<GottWieGrossIstDeineGuteViewer />}
              />
              <Route
                path="/sheet-music/gib-dich-zufrieden-und-sei-stille"
                element={<GibDichZufriedenUndSeiStilleViewer />}
              />
              <Route
                path="/sheet-music/gib-dich-zufrieden-und-sei-stille-d-minor"
                element={<GibDichZufriedenUndSeiStilleDMinorViewer />}
              />
              <Route
                path="/sheet-music/aria-bwv-515"
                element={<AriaBWV515Viewer />}
              />
              <Route
                path="/sheet-music/warum-betrubst-du-dich"
                element={<WarumBetrubstDuDichViewer />}
              />
              <Route
                path="/sheet-music/invention-no-2"
                element={<InventionNo2Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-3"
                element={<InventionNo3Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-4"
                element={<InventionNo4Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-5"
                element={<InventionNo5Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-7"
                element={<InventionNo7Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-8"
                element={<InventionNo8Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-10"
                element={<InventionNo10Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-11"
                element={<InventionNo11Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-13"
                element={<InventionNo13Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-14"
                element={<InventionNo14Viewer />}
              />
              <Route
                path="/sheet-music/invention-no-15"
                element={<InventionNo15Viewer />}
              />
              <Route
                path="/sheet-music/view/:id"
                element={<GenericSheetMusicViewer />}
              />

              {/* Student registration flow - NO AUTH GUARD */}
              <Route
                path="/instrument-selection"
                element={<InstrumentSelectionPage />}
              />
              <Route
                path="/teacher-matching"
                element={<TeacherMatchingPage />}
              />

              {/* Payment related routes */}
              <Route
                path="/payment-methods"
                element={
                  <StudentLayout>
                    <PaymentMethodsPage />
                  </StudentLayout>
                }
              />
              <Route
                path="/transaction-history"
                element={
                  <StudentLayout>
                    <TransactionHistoryPage />
                  </StudentLayout>
                }
              />
              <Route
                path="/subscription"
                element={
                  <StudentLayout>
                    <SubscriptionManagementPage />
                  </StudentLayout>
                }
              />

              {/* Account Management Routes - Role-aware, will apply teacher verification through RoleAwareLayout */}
              <Route
                path="/my-info"
                element={
                  <RoleAwareLayout>
                    <MyInfoPage />
                  </RoleAwareLayout>
                }
              />
              <Route
                path="/settings"
                element={
                  <RoleAwareLayout>
                    <SettingsPage />
                  </RoleAwareLayout>
                }
              />
              <Route
                path="/account-security"
                element={
                  <RoleAwareLayout>
                    <AccountSecurityPage />
                  </RoleAwareLayout>
                }
              />
              <Route
                path="/billing-payouts"
                element={
                  <RoleAwareLayout>
                    <BillingPayoutsPage />
                  </RoleAwareLayout>
                }
              />
              <Route
                path="/help-support"
                element={
                  <RoleAwareLayout>
                    <HelpSupportPage />
                  </RoleAwareLayout>
                }
              />

              {/* Public info pages - NO AUTH GUARD */}
              <Route
                path="/about"
                element={
                  <TeacherLayout>
                    <AboutUsPage />
                  </TeacherLayout>
                }
              />
              <Route path="/careers" element={<CareersPage />} />
              <Route
                path="/knowledge-base/getting-started"
                element={
                  <TeacherLayout>
                    <KnowledgeBaseGettingStarted />
                  </TeacherLayout>
                }
              />
              <Route
                path="/knowledge-base/scheduling-lessons"
                element={
                  <TeacherLayout>
                    <KnowledgeBaseSchedulingLessons />
                  </TeacherLayout>
                }
              />
              <Route
                path="/knowledge-base/virtual-classroom"
                element={
                  <TeacherLayout>
                    <KnowledgeBaseVirtualClassroom />
                  </TeacherLayout>
                }
              />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route
                path="/terms-of-service"
                element={<TermsOfServicePage />}
              />
            </Routes>
            {/* Single instance of SignInModal */}
            <SignInModal
              isOpen={isSignInModalOpen}
              onClose={closeSignInModal}
            />
            {/* Single instance of TeacherLoginModal */}
            <TeacherLoginModal
              isOpen={isTeacherLoginModalOpen}
              onClose={closeTeacherLoginModal}
            />
            {/* Add ToastContainer */}
            <ToastContainer position="top-right" />
            {/* Add Toaster for react-hot-toast */}
            <Toaster
              position="top-center"
              toastOptions={{
                duration: 5000,
                style: {
                  background: theme === 'dark' ? '#1A2A52' : '#ffffff',
                  color: theme === 'dark' ? '#ffffff' : '#1f2937',
                  minWidth: '300px',
                  padding: '16px',
                  fontSize: '14px',
                },
                success: {
                  iconTheme: {
                    primary: '#4ade80',
                    secondary: 'white',
                  },
                  style: {
                    background: theme === 'dark' ? '#1A2A52' : '#ffffff',
                    border:
                      theme === 'dark'
                        ? '1px solid rgba(74, 222, 128, 0.3)'
                        : '1px solid rgba(74, 222, 128, 0.2)',
                  },
                },
              }}
              containerStyle={{
                top: 80,
                zIndex: 9999,
              }}
            />
          </BrowserRouter>
          <style jsx global>{`
            html {
              scroll-behavior: smooth;
            }
            /* Global CSS variables for dropdown styling */
            :root {
              --navy-700: #0a1128;
              --navy-800: #1a2a52;
              --navy-900: #0f1626;
              --deep-pink: #e63946;
              --dropdown-shadow:
                0 10px 15px -3px rgba(0, 0, 0, 0.1),
                0 4px 6px -2px rgba(0, 0, 0, 0.05);
            }
            /* Global select dropdown styling - use CSS variables for theming */
            select option {
              background-color: var(--dropdown-bg, #1f2937);
              color: var(--dropdown-text, white);
            }
            select option:checked {
              background-color: var(--dropdown-bg-selected, #394b6c);
              color: var(--dropdown-text-selected, white);
            }
            select option:hover {
              background-color: var(--dropdown-bg-hover, #2e3e5c);
            }
            select {
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
              background-position: right 0.5rem center;
              background-repeat: no-repeat;
              background-size: 1.5em 1.5em;
              padding-right: 2.5rem;
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              border-radius: 0.5rem;
            }
            select:focus {
              z-index: 10;
            }
            select::-ms-expand {
              display: none;
            }
            select option:checked,
            select option:focus,
            select option:active,
            select option:hover:checked {
              background-color: var(--dropdown-bg-selected, #394b6c) !important;
              color: var(--dropdown-text-selected, white) !important;
              box-shadow: 0 0 10px 100px var(--dropdown-bg-selected, #394b6c)
                inset !important;
              -webkit-text-fill-color: var(
                --dropdown-text-selected,
                white
              ) !important;
            }
            /* Dark mode styles for date and time inputs */
            input[type='date'],
            input[type='time'] {
              color-scheme: auto;
            }
            .bg-navy-900 input[type='date'],
            .bg-navy-900 input[type='time'],
            .bg-navy-800 input[type='date'],
            .bg-navy-800 input[type='time'] {
              color-scheme: dark;
            }
            /* Specific dark mode overrides for navy theme */
            .bg-navy-900 {
              background-color: #0a1128 !important;
            }
            .bg-navy-800 {
              background-color: #1a2a52 !important;
            }
            /* Calendar and time picker dropdown styling */
            .bg-navy-900::-webkit-calendar-picker-indicator,
            .bg-navy-800::-webkit-calendar-picker-indicator {
              filter: invert(1);
              background-color: transparent;
            }
            /* Time dropdown styling for dark mode */
            input[type='time']::-webkit-calendar-picker-indicator {
              background-color: transparent;
            }
            /* Dark mode time dropdown background */
            input[type='time']::-webkit-time-picker,
            input[type='time']::-webkit-datetime-edit,
            input[type='time']::-webkit-inner-spin-button,
            input[type='time']::-webkit-clear-button {
              color: white;
            }
            /* Style the time dropdown background in dark mode */
            .bg-navy-900 input[type='time']::-webkit-list-button,
            .bg-navy-800 input[type='time']::-webkit-list-button,
            .bg-navy-900 input[type='time']::-webkit-time-picker,
            .bg-navy-800 input[type='time']::-webkit-time-picker,
            .bg-navy-900
              input[type='time']::-webkit-datetime-edit-fields-wrapper,
            .bg-navy-800
              input[type='time']::-webkit-datetime-edit-fields-wrapper {
              background-color: rgba(
                26,
                42,
                82,
                0.5
              ); /* #1A2A52 with 50% opacity */
              color: white;
            }
            /* Weekend cells style for time dropdown */
            .bg-navy-900 input[type='time'].weekend::-webkit-time-picker,
            .bg-navy-800 input[type='time'].weekend::-webkit-time-picker {
              background-color: rgba(
                26,
                42,
                82,
                0.3
              ); /* #1A2A52 with 30% opacity */
            }
            /* Override browser default styles for the time dropdown in dark mode */
            @media (prefers-color-scheme: dark) {
              input[type='time']::-webkit-calendar-picker-dropdown {
                background-color: rgba(
                  26,
                  42,
                  82,
                  0.5
                ) !important; /* #1A2A52 with 50% opacity */
              }
            }
            /* Firefox specific styles for dark mode time picker */
            @-moz-document url-prefix() {
              .bg-navy-900 input[type='time'],
              .bg-navy-800 input[type='time'] {
                background-color: rgba(
                  26,
                  42,
                  82,
                  0.5
                ); /* #1A2A52 with 50% opacity */
                color: white;
              }
            }
            /* Light background override */
            .bg-white select option {
              background-color: white;
              color: #1f2937;
            }
            .bg-white select option:checked {
              background-color: #394b6c;
              color: white;
            }
            .bg-white select option:hover {
              background-color: #f3f4f6;
              color: #1f2937;
            }
            .bg-white select option:checked,
            .bg-white select option:focus,
            .bg-white select option:active,
            .bg-white select option:hover:checked {
              background-color: #394b6c !important;
              color: white !important;
              box-shadow: 0 0 10px 100px #394b6c inset !important;
            }
            /* Remove the hardcoded student dropdown styles that were overriding our theme variables */
            /* The styles below will be replaced by the component-level CSS in FindTeachers.tsx */
          `}</style>
        </div>
      </SignInModalContext.Provider>
    </AuthProvider>
  )
}
export function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  )
}
